module.exports = __webpack_public_path__ + "static/media/lentz_long.d80fe22d.jpg";